
// 增加页签
const addTab = ({commit}, target) => {
    commit('AddTab', target);
};

// 删除页签
const removeTab = ({commit}, target) => {
    commit('RemoveTab', target);
};

// 删除页签
const clickTab = ({commit}, target) => {
    commit('ClickTab', target);
};

// 权限
const setPermission = ({commit}, target) => {
    commit('SetPermission', target);
};


export {
    addTab,
    removeTab,
    clickTab,
    setPermission
};


// WEBPACK FOOTER //
// ./src/store/actions.js